(() => {
  if (window.psnGameCarousels) return;
  window.psnGameCarousels = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  async function init(section) {
    const rail = section.querySelector('[data-carousel-rail]');
    if (!rail || section.dataset.carouselReady) return;
    section.dataset.carouselReady = 'true';
    const prev = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    const pageLink = section.querySelector('[data-carousel-page]');
    const status = section.querySelector('[data-carousel-status]');
    const update = () => {
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    const move = direction => {
      const card = rail.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(rail).gap) || 0;
      const width = card.getBoundingClientRect().width + gap;
      const count = Math.max(1, Math.round((rail.clientWidth + gap) / width));
      rail.scrollBy({left: direction * width * count, behavior: reduced.matches ? 'auto' : 'smooth'});
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('keydown', e => {
      if (e.target !== rail || !['ArrowLeft','ArrowRight'].includes(e.key)) return;
      e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1);
    });
    rail.addEventListener('scroll', update, {passive:true});
    const observer = new ResizeObserver(update); observer.observe(rail);
    section.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
    function shuffle() {
      if (section.dataset.randomize !== 'true') return;
      const cards = [...rail.children];
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      rail.replaceChildren(...cards);
    }
    shuffle(); update();
    if (!pageLink) return;
    pageLink.hidden = true;
    const seen = new Set([...rail.children].map(card => card.dataset.product));
    const visited = new Set();
    let url = new URL(pageLink.href);
    try {
      while (url) {
        if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid pagination');
        visited.add(url.href);
        pageLink.href = url.href;
        const response = await fetch(url.href);
        if (!response.ok) throw new Error('Loading failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const container = section.dataset.gameCarousel === 'search'
          ? doc.querySelector('[data-game-carousel="search"]') : doc;
        const source = container?.querySelector('[data-carousel-rail], [data-more-page]');
        if (!source) throw new Error('Missing products');
        const cards = [...source.querySelectorAll('.catalog-card')];
        for (const card of cards) {
          if (!seen.has(card.dataset.product)) {seen.add(card.dataset.product); rail.append(card);}
        }
        const link = container.querySelector('[data-carousel-page], [data-more-page-next]');
        url = link ? new URL(link.getAttribute('href'), url.href) : null;
        if (url && section.dataset.gameCarousel === 'recommendations') url.searchParams.set('view','more-cards');
      }
      shuffle(); update();
    } catch {
      status.textContent = 'No se pudieron cargar más juegos. Puedes continuar aquí:';
      pageLink.hidden = false; update();
    }
  }
  const scan = () => document.querySelectorAll('[data-game-carousel]').forEach(init);
  scan(); document.addEventListener('shopify:section:load', scan);
})();
